export default "__VITE_ASSET__DVQLlN_A__"